import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { footerConfig } from './config'
import styles from './footer.module.css'
import { typographyColor, typographyType, typographyAs } from '../typography/constants'
import Typography from '../typography/Typography'


const Footer: FC<{ isUk: boolean; }> = ({ isUk }) => {
    const { t } = useTranslation()

    const currentYear = new Date().getFullYear()

    const legalItems = isUk ? footerConfig.footerItems.slice(0, -1) : footerConfig.footerItems

    const legalHost = isUk ? import.meta.env.VITE_BANXE_UK_PATH : import.meta.env.VITE_BANXE_COM_PATH

    const legalLinks = footerConfig.legalLinks
        .slice(0, isUk ? -1 : undefined)
        .map(item => ({
            ...item,
            href: `${legalHost}${item.href}`,
        }))

    return (
        <footer className={styles.footer}>
            <div className={styles.search}>
                <div className={styles.legalContent}>
                    {legalLinks.map((link, idx) => (
                        <a
                            key={idx}
                            href={link?.href}
                            className={styles.legalContentItem}
                        >
                            <Typography
                                type={typographyType.link}
                                color={typographyColor.tertiary}
                                as={typographyAs.span}
                                className={styles.legalLink}
                            >
                                {t(link?.title)}
                            </Typography>
                        </a>
                    ))}
                </div>
            </div>
            <hr className={styles.line} />
            <div className={styles.additional}>
                <Typography
                    type={typographyType.caption}
                    color={typographyColor.secondaryInverted}
                >
                    {t(footerConfig.copyright, { year: currentYear })}
                </Typography>
                {legalItems?.map((item, index) => (
                    <Typography
                        key={index}
                        type={typographyType.caption}
                        color={typographyColor.secondaryInverted}
                    >
                        {t(item)}
                    </Typography>
                ))
                }
            </div>
        </footer>
    )
}

export default Footer

